module.exports = __webpack_public_path__ + "static/media/fuu_dirgha.6d2aa94a.ogg";